import { createAction } from '@reduxjs/toolkit';

export const asyncGetSubscriptions = createAction('[async] asyncGetSubscriptions');
export const asyncGetSubscriptionsSuccess = createAction('[async] asyncGetSubscriptionsSuccess');
